export default __webpack_public_path__ + "static/media/app.11cb5cf1.pdf";